<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>汇报</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <div class="head">
        <img src="@/assets/director/workmaster/report.png"></img>
        <div>
            <p class="title">汇报</p>
            <p class="desc">对企业对员工工作内容及过程的管理功能企业对员工规则，为员工提供标准化 的汇报渠道</p>
        </div>
    </div>

    <div class="cont">

      <p style="font-weight:bold;display: flex;justify-content: space-between;">
        <span>设置列表</span>
        <span @click="addSet">添加设置</span>
      </p>
      
      <div class="clock-list">
          <div class="unit"  v-for="(item, index) in pageProps.records" :key="index">
              <div class="title">{{item.title}}</div>
              <div class="op">
                 <p class="btns"> 
                    <span @click="delHead(item)">删除</span>
                    <span @click="editHead(item)">编辑</span>
                </p>
              </div>
          </div>
      </div>

      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <p style="font-weight:bold">汇报数据管理</p>
      <div class="edit-list">
        <div class="unit" @click="reportList(1)">
            <img src="@/assets/director/workmaster/icon-report.png"></img>
            <p class="title">日报</p>
        </div>

        <div class="unit" @click="reportList(2)">
            <img src="@/assets/director/workmaster/icon-report.png"></img>
            <p class="title">周报</p>
        </div>

        <div class="unit" @click="reportList(3)">
            <img src="@/assets/director/workmaster/icon-report.png"></img>
            <p class="title">月报</p>
        </div>
      </div>
      
   

    </div>
    
  </div>
</template>

<script>
import { reportSetDel,reportSetLists } from "@/api/director/report/index.js";

export default {
    name: "Director-Work-CLock",
    data() {
      return {
       
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          name:"",
          page:0,
          limit:0
        }

      }
    },

    mounted() {
      this.fetchData();
    },



    methods: {

      reportList(type){
        
        this.$router.push({path:'/director-workmaster-report-list',query:{type:type}});

      },



      addSet(){
        this.$router.push({path:'/director-workmaster-report-set',query:{a:123456}});
        
      },
      editHead(item){
        this.$router.push({path:'/director-workmaster-report-set',query:{job_id:item.job_id,type:item.type}});
      },


      delHead(item){
        var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          reportSetDel({id:item.id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }
            });
          
        }).catch(() => {
        
        });
      },

     


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        reportSetLists(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    margin-top: 10px;
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      margin-bottom: 20px;
      display: flex;
      align-self: center;

      img{
        width: 18px;
        height: 23px;
        margin-right: 20px;

      }

      .title{
        text-align: left;
      }

    }
  }
}
</style>